// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
// Components, Layouts, Pages
import { BaseLabel } from '~/components/common';
// Others
import { EMPTY_VALUE } from '~/utils/constants/common';
import { IOrderDetail } from '~/utils/interface/order';
import { IQuoteDetail } from '~/utils/interface/quotes';
// Styles, images, icons
import styles from './NoteQuoteDetail.module.scss';
import { icons } from '~/assets';

type Props = {
  orderDetail?: IOrderDetail;
  detailQuote?: IQuoteDetail;
};

const cx = classNames.bind(styles);

const NoteQuoteDetail = (props: Props) => {
  //#region Destructuring Props
  const { detailQuote, orderDetail } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/quotes', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [data, setData] = useState<IQuoteDetail | IOrderDetail | undefined>(detailQuote || orderDetail);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    setData(detailQuote || orderDetail);
  }, [detailQuote, orderDetail]);
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack id='noteQuoteDetailComponent' className={cx('container')} gap={6}>
      <BaseLabel styleType='title' label={t('form_quotes_title_internal_notes')} icon={icons.commonIconNote} />

      <Typography className={cx('value')}>{data?.internalNote || EMPTY_VALUE}</Typography>
    </Stack>
  );
};

export default NoteQuoteDetail;
